module.exports = __webpack_public_path__ + "media/images/icon-accordion-closed-402104bf2b53ae1d56e3bc31dd86df33.svg";